import type { StoreApi, UseBoundStore } from "zustand";
import { create } from "zustand";

import type { StoreSelectors } from "./store.ts";
import { createStoreProxy, createStoreSelectors } from "./store.ts";

export interface AsyncStatusState {
  readonly error: null | string;
  readonly isPending: boolean;
}

interface AsyncStatusActions {
  readonly setError: (error: string) => void;
  readonly setIsPending: (isPending: boolean) => void;
}

export interface AsyncStatusStore
  extends AsyncStatusActions,
    AsyncStatusState {}

interface AsyncStatusStoreResult {
  readonly asyncStatusSelectors: StoreSelectors<AsyncStatusState>;
  readonly asyncStatusStore: AsyncStatusStore;
  readonly useAsyncStatusStore: UseBoundStore<StoreApi<AsyncStatusStore>>;
}

export function createAsyncStatusStore(): AsyncStatusStoreResult {
  const initialState: AsyncStatusState = { error: null, isPending: false };
  const useAsyncStatusStore = create<AsyncStatusStore>()(set => {
    return {
      ...initialState,
      setError: (error: string) => {
        set({ error });
      },
      setIsPending: (isPending: boolean) => {
        set({ isPending });
      },
    };
  });

  const asyncStatusStore = createStoreProxy(useAsyncStatusStore.getState);

  const asyncStatusSelectors = createStoreSelectors<AsyncStatusState>();

  return { asyncStatusSelectors, asyncStatusStore, useAsyncStatusStore };
}
